"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTextMessage = exports.isVoiceMessage = exports.isDocumentMessage = exports.isPictureMessage = exports.isSystemMessage = exports.isMessage = void 0;
function isMessage(message) {
    return !isSystemMessage(message);
}
exports.isMessage = isMessage;
function isSystemMessage(message) {
    return message.action !== undefined;
}
exports.isSystemMessage = isSystemMessage;
function isPictureMessage(message) {
    return 'images' in message;
}
exports.isPictureMessage = isPictureMessage;
function isDocumentMessage(message) {
    return 'attachments' in message;
}
exports.isDocumentMessage = isDocumentMessage;
function isVoiceMessage(message) {
    return 'voice' in message;
}
exports.isVoiceMessage = isVoiceMessage;
function isTextMessage(message) {
    return 'text' in message && !(isPictureMessage(message) && isDocumentMessage(message));
}
exports.isTextMessage = isTextMessage;
